'use client';
import { ThemeContext } from './provider';
import { useContext } from 'react';
import selectTheme from '@banzai/themes/select-theme';

export function useTheme() {
  const configContext = useContext(ThemeContext);
  
  if (!configContext) {
    const defaultTheme = selectTheme('banzai');
    return { theme: defaultTheme, darkMode: false };
  }
  
  const actualTheme = selectTheme(configContext.themeId);
  return { theme: actualTheme, darkMode: configContext.darkMode };
}
